import {Dropdown, Layout} from 'antd'
import classNames from 'classnames'
import React, {useContext} from 'react'
import {Link, useLocation} from 'react-router-dom'

import {UserContext} from 'utils/userContext'

import {Item, navBarItems} from 'components/appContainer/navBarItems'

import {logoImage} from 'assets/images'

import styles from 'components/appContainer/appContainer.module.scss'

interface Props {
  children: React.ReactNode
}

export const AppContainer: React.FC<Props> = ({children}) => {
  const location = useLocation()
  const {logoDataURI, userRole} = useContext(UserContext)

  function asLink(item: Item, preventDefault?: boolean) {
    return <Link
      key={item.name}
      to={item.to ?? ''}
      onClick={(e) => preventDefault && e.preventDefault()}
      className={classNames(styles.link, {
        [styles.link_active]: location.pathname.startsWith(item.to as string),
      })}
    >
      {item.image}
      {item.name}
    </Link>
  }

  return (
    <Layout>
      <Layout.Header className={styles.header}>
        <img src={logoDataURI ?? logoImage} className={styles.logo} />

        <nav className={styles.links}>
          {navBarItems.map(
            (item) =>
              (!item.role || item.role === userRole) &&
              (item.spacing ? (
                <div key={item.name} className={styles.spacing} />
              ) : (
                item.items ?
                  <Dropdown menu={{items: item.items.map(elem => ({key: 1, label: asLink(elem)}))}}
                            trigger={["click"]} placement="bottomCenter"
                            dropdownRender={(menu) =>
                              <div style={{transform: "translateY(-20px)"}}>{menu}</div>
                            }
                  >
                    {asLink(item, true)}
                  </Dropdown>
                  : asLink(item)
              )),
          )}
        </nav>
      </Layout.Header>

      <Layout.Content className={styles.content}>{children}</Layout.Content>
    </Layout>
  )
}
